require('./').polyfill()



/*****************
 ** WEBPACK FOOTER
 ** ./~/raf/polyfill.js
 ** module id = 1495
 ** module chunks = 0
 **/